import { Injectable } from '@angular/core';
import { RestfulApiService } from './restful-api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  private readonly resourceUrl: string = '/v1/home';

  // prettier-ignore
  constructor(
    private apiService: RestfulApiService
  ) {
  }

  getLandingPage(languageCode: string): Observable<any> {
    return this.apiService.post(`${this.resourceUrl}/landing-page`, {}, { languageCode });
  }
}
